import { useEffect, useMemo, useState } from 'react'
import { useSession } from 'next-auth/react'

import NumberFormat from 'react-number-format';

import styles from './styles.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faChevronDown, faChevronLeft, faCoins, faList, faListCheck, faListSquares, faMapLocationDot, faPlusCircle, faPlusSquare, faXmark, faXmarkCircle } from '@fortawesome/free-solid-svg-icons';

import categoryName from '../../../../Functions/categoryName';

import { PulseLoader, BarLoader } from 'react-spinners';

import GridDragAndDrop from '../../../../Misc/GridDragAndDrop/GridDragAndDrop';
import MapWithRadius from '../../../../Misc/MapWithRadius/MapWithRadius';

import errorMsg from '../../../../Functions/errorMsg';
import successMsg from '../../../../Functions/successMsg';

import axios from 'axios';

import PolicyPage from '../../../../Home/Policies/Policies';

import MapWithLocation from '../../../../Misc/MapWithLocation/MapWithLocation';

import Resizer from 'react-image-file-resizer'

import ToggleSwitch from '../../../../FunctionalComponents/ToggleSwitch';
import { useRouter } from 'next/router';

export default function CreatePost({ setCreateAuction, refreshListings }) {

    const { data: session, status } = useSession();

    const serviceCost = 20;

    const [policyPage, showPolicyPage] = useState(false);

    const [mapType, setMapType] = useState(null);

    /* Handle Listing Create Upload */

    const [pendingRequest, setPendingRequest] = useState(false);

    async function handleCreateListing(data) {
        if(pendingRequest === true) return;
        if(data === null) return errorMsg("We ran into an issue creating your post, please contact us if the issue persists.");
        if(!session || status !== 'authenticated') return errorMsg("You're not authenticated to create a post, please re-login.");
        if(typeof window === 'undefined') return;
        const heic2any = require('heic2any');

        setPendingRequest(true);

        console.log(data.toUpload);

        const resizeImages = await Promise.all(
            data.toUpload.map(async (image, index) => {
              try {
                var fileSize = (image.imageFile.size / (1024 * 1024)).toFixed(2);
                if (fileSize > 8) {
                  errorMsg("Image is too large, images can be no bigger than 8mb");
                  return;
                }
          
                let resizedImage;
                if (image.imageFile.name.includes('.HEIC')) {
                  const jpegBlob = await heic2any({ blob: image.imageFile, toType: 'image/jpeg' });
                  resizedImage = await resizeFile(jpegBlob);
                } else {
                  resizedImage = await resizeFile(image.imageFile);
                }
          
                return { position: index + 1, image: resizedImage };
              } catch (error) {
                console.error("Error resizing image:", error);
                errorMsg("We could not upload your image, please try again later or contact us");
                setPendingRequest(false);
                return;
              }
            })
          ).catch(() => {
            errorMsg("We could not upload your image, please try again later or contact us");
            setPendingRequest(false);
            return;
          });

        var manipulatedData = {...data};
        manipulatedData.images = resizeImages;
        delete manipulatedData.toUpload;

        const apiResult = await axios.post(`${window.location.origin}/api/auctionHub/createAuctionListing`, { data: manipulatedData }).catch((error) => { 
            errorMsg(error?.response?.data?.status || error.toString());
            setPendingRequest(false);
        });
      
        if(apiResult && apiResult.status === 200) {
            setCreateAuction(false);
            successMsg("Your auction is now active.");
            setPendingRequest(false);
            refreshListings();
        }

    }

    const resizeFile = (file) =>
    new Promise((resolve, reject) => {
      Resizer.imageFileResizer(
        file,
        1500,
        1500,
        "PNG",
        100,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        200,
        200
      );
    });

    function handleBack() {
        setMapType(null);
        setCreateAuction(false);
    }

    /* Auction Listing Data Handling */
    // ===============================
    // ===============================

    const [uploads, setUploads] = useState([]);

    const [title, setTitle] = useState("");
    const [itemPrice, setItemPrice] = useState("");
    const [desc, setDesc] = useState("");
    const [zip, setZIP] = useState("");

    const [acceptPayments, setAcceptPayments] = useState(false);

    const [auctionDetails, setAuctionDetails] = useState([{ type: '', detail: '' }]);

        // Function to add a new detail set
        const addDetailSet = () => {
            setAuctionDetails(prevDetails => [
                ...prevDetails,
                { type: '', detail: '' }
            ]);
        };
    
        // Function to remove a detail set
        const removeDetail = (indexToRemove) => {
            setAuctionDetails(prevDetails => prevDetails.filter((_, index) => index !== indexToRemove));
        };
    
        // Function to handle changes in type or detail
        const handleDetailChange = (index, field, value) => {
            setAuctionDetails(prevDetails => {
                const updatedDetails = [...prevDetails];
                updatedDetails[index] = {
                    ...updatedDetails[index],
                    [field]: value
                };
                return updatedDetails;
            });
        };

    useEffect(() => {
        if(zip.length === 5 || zip.length === 10) {
            setMapType({ type: "ZIP", zip: zip });
        } else {
            setMapType(null);
        }
    }, [zip])

    const handleZIPChange = (e) => {
        let inputValue = e.target.value;

        inputValue = inputValue.replace(/\D/g, '');

        if (inputValue.length > 5) {
          inputValue = inputValue.slice(0, 5) + '-' + inputValue.slice(5);
        }

        inputValue = inputValue.slice(0, 10);

        setZIP(inputValue);
    };

    const [itemCondition, setItemCondition] = useState('Select Condition');
    const [conditionMenu, showConditionMenu] = useState(false);
  
    function selectItemCondition(e, category) {
        e.preventDefault()
        if(category === itemCondition) return;
        setItemCondition(category);
        showConditionMenu(false)
    }

    const [itemCategory, setItemCategory] = useState('Select Category');
    const [categoryMenu, showCategoryMenu] = useState(false);

    const changeItemCategory = (e, catID) => {
        e.preventDefault();
        if(catID === itemCategory) return;
        setItemCategory(categoryName(catID));
        showCategoryMenu(false);
    }

    const [meetupPref, setMeetupPref] = useState('Meetup Preference');
    const [meetupMenu, showMeetupMenu] = useState(false);
  
    function selectMeetupPreference(e, preference) {
        e.preventDefault()
        if(preference === meetupPref) return;
        setMeetupPref(preference);
        showMeetupMenu(false)
    }

    const [auctionDuration, setAuctionDuration] = useState('Auction Duration');
    const [durationMenu, showDurationMenu] = useState(false);
  
    function selectDuration(e, duration) {
        e.preventDefault()
        if(duration === auctionDuration) return;
        setAuctionDuration(duration);
        showDurationMenu(false)
    }

    const priceValueCap = (inputObj) => {
        const { value } = inputObj;
        if (value <= 1000000) return true;
        return false;
    };

    function handleSubmit() {

        if(acceptPayments === 'loading') return errorMsg("You have an operation pending, please wait.");

        const listingData = {
            userID: session.user.token.id,
            owner: session.user.token.username,
            title: title,
            description: desc,
            category: itemCategory,
            condition: itemCondition,
            meetupPref: meetupPref,
            price: itemPrice,
            auctionDuration: auctionDuration,
            auctionDetails: auctionDetails,
            zip: zip,
            toUpload: uploads,
            creationDate: new Date().toISOString()
        }

        if (acceptPayments) {
            listingData.acceptPayments = {
                enabled: true,
                cost: serviceCost,
                purchaseOptions: paymentData.purchaseOptions,
                refundPolicy: paymentData.refundPolicy,
            }
        } else {
            listingData.acceptPayments = {
                enabled: false,
                cost: null,
                purchaseOptions: [],
                refundPolicy: '',
            }
        }

        handleCreateListing(listingData);
    }

    const [canSubmit, setCanSubmit] = useState(false);

    useEffect(() => {
        if(uploads.length === 0 ||
        title.length < 5 || title.length > 50 ||
        itemPrice.length === 0 || parseInt(itemPrice) === 0 ||
        desc.length < 15 ||
        itemCondition === 'Select Condition' ||
        itemCategory === 'Select Category' ||
        meetupPref === 'Meetup Preference' ||
        auctionDuration === 'Auction Duration' ||
        (auctionDetails.length > 0 && auctionDetails.some(set => set.type.trim() === '' || set.detail.trim() === '')) ||
        acceptPayments === 'loading' ||
        zip.length < 5) {
            setCanSubmit(false);
        } else {
            setCanSubmit(true);
        }
    }, [uploads, title, itemPrice, desc, itemCondition, auctionDetails, auctionDuration, itemCategory, meetupPref, zip, acceptPayments])

    const [confirmGoBack, setConfirmGoBack] = useState(false);

    function handleConfirmBack() {
        if(uploads.length > 0 || (title.length > 5 && title.length <= 50) || itemPrice.length > 0 || desc.length > 15 || itemCondition !== 'Select Condition' || itemCategory !== 'Select Category' || meetupPref !== 'Meetup Preference' || auctionDuration !== 'Auction Duration'  || zip.length > 0) {
            setConfirmGoBack(true);
        } else {
            handleBack();
        }
    }

    const memoizeImageGrid = useMemo(() => <GridDragAndDrop initialImages={null} pendingRequest={pendingRequest} receiveUploadData={(newUploads) => setUploads(newUploads)}  />, [pendingRequest])

    /*
        Under $100: Increments of $1 or $5 are common. For example:
            $0.01 - $10: $1 increments
            $10 - $50: $5 increments
            $50 - $100: $10 increments

        Between $100 and $500: Increments of $5 or $10 are typical. For example:
            $100 - $200: $5 increments
            $200 - $500: $10 increments

        Between $500 and $1,000: Increments of $10 or $25 are common. For example:
            $500 - $750: $10 increments
            $750 - $1,000: $25 increments

        Between $1,000 and $5,000: Increments of $50 or $100 are often used. For example:
            $1,000 - $2,000: $50 increments
            $2,000 - $5,000: $100 increments

        Above $5,000: Increments may increase to $100, $250, or even $500, depending on the value of the item being auctioned.
    */

  return (
    <section id={styles.wrapper}>

        { policyPage === true && <section id={styles.policyContainer}> <FontAwesomeIcon onClick={() => showPolicyPage(false)} icon={faXmarkCircle} id={styles.exitPolicy} /> <PolicyPage /> </section> }

        <div id={styles.form}>

            <section id={styles.sellanitem}>

                { confirmGoBack === true && <section id={styles.confirmGoBack}>
                    <div>
                        <div>
                            <h1>Discard Draft?</h1>
                            <span>
                                <button id={styles.confirm} onClick={() => handleBack()}>
                                    <FontAwesomeIcon icon={faCheck} id={styles.icon} />
                                </button>
                                <button id={styles.cancel} onClick={() => setConfirmGoBack(false)}>
                                    <FontAwesomeIcon icon={faXmark} id={styles.icon} />
                                </button>
                            </span>
                        </div>
                    </div>
                </section> }

                <section id={styles.wrapper}>

                    <FontAwesomeIcon icon={faChevronLeft} id={styles.goBack} onClick={() => handleConfirmBack()} />

                    <div id={styles.gridContainer}>
                        <h1>{uploads.length} / 12 slots available</h1>
                        { memoizeImageGrid }
                    </div>

                    <div id={styles.enterInfo}>
                        <h1>Listing Details</h1>

                        <section id={styles.title}>
                            <input disabled={pendingRequest} onChange={(e) => setTitle(e.target.value)} type='text' placeholder="Title" maxLength={50} />
                            {title !== null && ( title.length < 5 && <h6>{title.length - 5}</h6> )}
                        </section>

                        <NumberFormat onValueChange={(values, sourceInfo) => {setItemPrice(values.value)}} isAllowed={priceValueCap} decimalSeparator={false} placeholder="Starting Bid $" thousandSeparator={true} prefix={'$'} />

                        <div onMouseLeave={() => showDurationMenu(false)} className={styles.dropdown}>
                            <button disabled={pendingRequest} style={{color: auctionDuration === 'Auction Duration' ? '#818181' : 'black'}} onClick={(e) => {e.preventDefault(); showDurationMenu(durationMenu ? false : true)} } className={styles.dropdownBtn}>{auctionDuration !== 'Auction Duration' ? `${auctionDuration} Days` : 'Auction Duration'} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                            <div style={{ height: 'auto', display: durationMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                                <button onClick={(e) => selectDuration(e, 3)}>3 Days</button>
                                <button onClick={(e) => selectDuration(e, 5)}>5 Days</button>
                                <button onClick={(e) => selectDuration(e, 7)}>7 Days</button>
                            </div>
                        </div>

                        <div onMouseLeave={() => showConditionMenu(false)} className={styles.dropdown}>
                            <button disabled={pendingRequest} style={{color: itemCondition === 'Select Condition' ? '#818181' : 'black'}} onClick={(e) => {e.preventDefault(); showConditionMenu(conditionMenu ? false : true)} } className={styles.dropdownBtn}>{itemCondition} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                            <div style={{ height: 'auto', display: conditionMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                                <button onClick={(e) => selectItemCondition(e, "New")}>New</button>
                                <button onClick={(e) => selectItemCondition(e, "Good")}>Good</button>
                                <button onClick={(e) => selectItemCondition(e, "Fair")}>Fair</button>
                                <button onClick={(e) => selectItemCondition(e, "For parts or not working")}>For parts or not working</button>
                            </div>
                        </div>

                        <div onMouseLeave={() => showCategoryMenu(false)} className={styles.dropdown}>
                        <button disabled={pendingRequest} style={{color: itemCategory === 'Select Category' ? '#818181' : 'black'}} onClick={ (e) => {e.preventDefault(); showCategoryMenu(categoryMenu ? false : true)} } className={styles.dropdownBtn}>{itemCategory} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                            <div style={{height: '200px', display: categoryMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                                <button onClick={(e) => changeItemCategory(e, 1)}>Antiques</button>
                                <button onClick={(e) => changeItemCategory(e, 2)}>Appliances</button>
                                <button onClick={(e) => changeItemCategory(e, 3)}>Art</button>
                                <button onClick={(e) => changeItemCategory(e, 4)}>Baby & Kids</button>
                                <button onClick={(e) => changeItemCategory(e, 5)}>Books</button>
                                <button onClick={(e) => changeItemCategory(e, 28)}>Cars & Trucks</button>
                                <button onClick={(e) => changeItemCategory(e, 31)}>Cars Parts</button>
                                <button onClick={(e) => changeItemCategory(e, 6)}>Cell Phones</button>
                                <button onClick={(e) => changeItemCategory(e, 7)}>Clothing</button>
                                <button onClick={(e) => changeItemCategory(e, 8)}>Collectibles</button>
                                <button onClick={(e) => changeItemCategory(e, 9)}>Computers</button>
                                <button onClick={(e) => changeItemCategory(e, 10)}>Crafts</button>
                                <button onClick={(e) => changeItemCategory(e, 11)}>Electronics</button>
                                <button onClick={(e) => changeItemCategory(e, 12)}>Furniture</button>
                                <button onClick={(e) => changeItemCategory(e, 13)}>Games & Toys</button>
                                <button onClick={(e) => changeItemCategory(e, 14)}>Health & Beauty</button>
                                <button onClick={(e) => changeItemCategory(e, 15)}>Hobbies</button>
                                <button onClick={(e) => changeItemCategory(e, 16)}>Home & Garden</button>
                                <button onClick={(e) => changeItemCategory(e, 17)}>Jewelry</button>
                                <button onClick={(e) => changeItemCategory(e, 18)}>Kitchenware</button>
                                <button onClick={(e) => changeItemCategory(e, 32)}>Miscellaneous</button>
                                <button onClick={(e) => changeItemCategory(e, 19)}>Musical Instruments</button>
                                <button onClick={(e) => changeItemCategory(e, 20)}>Music</button>
                                <button onClick={(e) => changeItemCategory(e, 21)}>Office Supplies</button>
                                <button onClick={(e) => changeItemCategory(e, 22)}>Outdoor Gear</button>
                                <button onClick={(e) => changeItemCategory(e, 23)}>Pet Supplies</button>
                                <button onClick={(e) => changeItemCategory(e, 24)}>Photography</button>
                                <button onClick={(e) => changeItemCategory(e, 25)}>Sporting Equipment</button>
                                <button onClick={(e) => changeItemCategory(e, 26)}>Sporting Goods</button>
                                <button onClick={(e) => changeItemCategory(e, 27)}>Tools</button>
                                <button onClick={(e) => changeItemCategory(e, 29)}>Video Games</button>
                                <button onClick={(e) => changeItemCategory(e, 30)}>Vintage Items</button>
                                <button onClick={(e) => changeItemCategory(e, 33)}>Other</button>
                            </div>
                        </div>

                        <section id={styles.addFeatures}>
                            <div>
                                <h1>Specific Details</h1>
                                <FontAwesomeIcon onClick={addDetailSet} icon={faPlusCircle} id={styles.icon} />
                            </div>
                            <div>
                                {auctionDetails.map((set, index) => (
                                    <span key={index} className={styles.detailCard}>
                                        <input
                                            type='text'
                                            placeholder='Part#'
                                            value={set.type}
                                            onChange={(e) => handleDetailChange(index, 'type', e.target.value)}
                                        />
                                        <input
                                            type='text'
                                            placeholder='PN34989123'
                                            value={set.detail}
                                            onChange={(e) => handleDetailChange(index, 'detail', e.target.value)}
                                        />
                                        <FontAwesomeIcon
                                            icon={faXmarkCircle}
                                            id={styles.removeDetail}
                                            onClick={() => removeDetail(index)}
                                        />
                                    </span>
                                ))}
                            </div>
                        </section>

                        <section id={styles.desc}>
                            <textarea disabled={pendingRequest} onChange={(e) => setDesc(e.target.value)} placeholder="Description" maxLength={2000} />
                            {desc !== null && ( desc.length < 15 && <h6>{desc.length - 15}</h6> )}
                        </section>
                        

                        <div onMouseLeave={() => showMeetupMenu(false)} className={styles.dropdown}>
                            <button disabled={pendingRequest} style={{color: meetupPref === 'Meetup Preference' ? '#818181' : 'black'}} onClick={(e) => {e.preventDefault(); showMeetupMenu(meetupMenu ? false : true)} } className={styles.dropdownBtn}>{meetupPref} <FontAwesomeIcon icon={faChevronDown} id={styles.icon} /></button>
                            <div style={{ height: 'auto', display: meetupMenu === false ? 'none' : 'block'}} className={styles.dropdownContent}>
                                <button onClick={(e) => selectMeetupPreference(e, "Public Meetup")}>Public Meetup</button>
                                <button onClick={(e) => selectMeetupPreference(e, "Drop Off")}>Drop Off</button>
                                <button onClick={(e) => selectMeetupPreference(e, "Pickup")}>Pickup</button>
                            </div>
                        </div>

                        <section id={styles.zip}>
                            <input disabled={pendingRequest} onChange={handleZIPChange} type='text' placeholder="ZIP Code" maxLength={10} value={zip} />
                        </section>
                        
                        <ListingMap zip={zip} />
                        { /* <PaymentsContainer setAcceptPayments={setAcceptPayments} serviceCost={serviceCost} /> */ }
                        

                        <p>Auctions items are public and can be seen by anyone on or off Waco Exchange. Items like animals, drugs, weapons, counterfeits, and other items that infringe intellectual property aren't allowed on Auctions. See our <b onClick={() => showPolicyPage(true)}>Policy Page</b> for more info.</p>
                        <button disabled={!canSubmit} onClick={handleSubmit} id={styles.createListing}>
                            { pendingRequest === true ? <PulseLoader size={15} color='white' /> : <> Create Listing <FontAwesomeIcon icon={faPlusSquare} id={styles.icon} /> </>}
                        </button>

                    </div>
                </section>
            </section>

        </div>
        <div id={styles.interactiveMap}>
            
            { (mapType !== null && mapType.type === 'ZIP' ) && <MapWithRadius zipCode={mapType.zip} /> }
            { (mapType !== null && mapType.type === 'Location' ) && <MapWithLocation address={mapType.address} city={mapType.city} zipCode={mapType.zip} /> }
            { mapType === null && <FontAwesomeIcon icon={faMapLocationDot} id={styles.icon} /> }

        </div>
    </section>
  )
}

const PaymentsContainer = ({ setAcceptPayments, serviceCost }) => {

    const router = useRouter();
    const { data: session, status } = useSession();

    const [pending, setPending] = useState(false);
    const [purchaseStatus, setPurchaseStatus] = useState(null);

    const [toggle, setToggle] = useState(false);

    function handleCreateFinanceAccount() {
        if(pendingRequest === true) return;
        window.open(`${window.location.origin}/financehub`, '_blank')
        setAcceptPayments(false);
    }

    async function handleTogglePayments(boolean) {
        if(!session) return router.push('/account/login');
        if(status === 'loading') return;
        if(status !== 'authenticated') return router.push('/account/login');
        setToggle(boolean);
        if(boolean) {
            setPending(true);
            setAcceptPayments('loading');
            const result = await axios.post(`${window.location.origin}/api/finance/account/purchasePower`, {
                userID: session.user.token.id
            }).catch((error) => {
                errorMsg(error.toString())
                setAcceptPayments(false);
                setToggle(false);
            })

            if(result && result.status === 200) {
                const accBalance = result.data.acc;
                if(accBalance === false) {
                    setPurchaseStatus("NO_ACCOUNT");
                    setAcceptPayments(false);
                    setToggle(false);
                } else {
                    if(parseInt(accBalance) < serviceCost) {
                        setPurchaseStatus("INSUFFICIENT_BALANCE");
                        setAcceptPayments(false);
                        setToggle(false);
                    } else {
                        setPurchaseStatus("CAN_PURCHASE");
                        setAcceptPayments(true);
                    }
                }
            }
            setPending(false);
        } else {
            setPurchaseStatus(null);
            setAcceptPayments(false);
        }
    }

    return (
        <section id={styles.acceptPayments}>

            <section id={styles.togglePayments}>
                <h1>Accept Online Payments<span>{serviceCost}<FontAwesomeIcon icon={faCoins} id={styles.icon} /></span></h1>
                <ToggleSwitch isDisabled={pending} state={toggle} setState={handleTogglePayments} />
            </section>

            { pending === true && <BarLoader color='#0da00d' width='100%' height='6px' /> }
            { purchaseStatus === 'NO_ACCOUNT' && <button onClick={handleCreateFinanceAccount} id={styles.signup}>Signup for Finance Account</button> }
            { purchaseStatus === 'INSUFFICIENT_BALANCE' && <section id={styles.insufficientBalance}><button id={styles.signup} onClick={handleCreateFinanceAccount}>Purchase More Coins</button>
            </section> }

        </section>
    )
}

/*



*/

const ListingMap = ({ zip }) => {

    function isMapViewable() {
        if(zip === null || zip === undefined) return false;
        if(zip.length === 5 || zip.length === 10) return true;
        return false;
    }

    return (
        <section id={styles.listingInteractiveMap}>
            { isMapViewable() && <MapWithRadius zipCode={zip} /> }
            { !isMapViewable() && <FontAwesomeIcon icon={faMapLocationDot} id={styles.icon} /> }
        </section>
    )
}